// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__19oj_","radioRow":"SimpleQuestionBuilderModal_radioRow__UzMLk"};